import React from 'react';
import { useBreakpointValue } from '@chakra-ui/react';
import { ToolbarProps } from 'react-big-calendar';
import { DesktopToolbar } from '.';
import { MobileToolbar } from '.';

export const CalendarToolbar: React.FC<ToolbarProps> = (
	props: ToolbarProps & { setCurrentMonth: React.Dispatch<React.SetStateAction<string>> }
) => {
	const isMobile = useBreakpointValue({ base: true, md: false });

	return isMobile ? <MobileToolbar {...props} /> : <DesktopToolbar {...props} />;
};
